import MyLicenses from "./my-licenses-redux";
export default MyLicenses;
